// extracted by mini-css-extract-plugin
export default {"container":"JR-z","topReviewHeading":"KR-z","criticalReview":"LR-z","favorableReview":"MR-z","vsSeparator":"NR-z"};